import React from "react";
import AppPagination from "@components/common/AppPagination";
import "./index.sass";

const MarketsTablePagination = (props) => <AppPagination {...props} />;

export default MarketsTablePagination;
